import * as fetch from './fetch';

export default {
  ...fetch,
};
